export default class ProfileEntity {
    constructor(profileData) {
        this.email = profileData?.email ?? ''
        this.firstname = profileData?.firstname ?? ''
        this.lastname = profileData?.lastname ?? ''
        this.phone = profileData?.phoneNumber ?? ''
        this.role = profileData?.role ?? ''
        this.language = profileData?.language?.localeCode ?? ''
        this.internalId = profileData?.internalId?.id ?? ''
    }
}